if (!customElements.get('catalog-buy-button')) {
  customElements.define(
    'catalog-buy-button',
    class CatalogBuyButton extends HTMLElement {
      constructor() {
        super();
        
        this.submitButton = this.querySelector('.catalog-buy-button');
        this.submitButtonText = this.querySelector('.catalog-buy-button-text');
        this.errorMessageWrapper = this.querySelector('.product-form__error-message-wrapper');
        this.errorMessage = this.errorMessageWrapper?.querySelector('.product-form__error-message');
        
        // Get tileo server URL from global scope or use default
        this.tileoServer = window.tileo_server || 'https://tileobackend-gub4adcgbxbqd3cx.westeurope-01.azurewebsites.net';
        
        if (this.submitButton) {
          this.submitButton.addEventListener('click', this.onSubmitHandler.bind(this));
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        
        if (this.submitButton.disabled || this.submitButton.getAttribute('aria-disabled') === 'true') {
          return;
        }

        // Show customer information form modal
        this.showCustomerForm();
      }

      showCustomerForm() {
        // Create modal overlay
        const modal = document.createElement('div');
        modal.className = 'catalog-order-modal';
        modal.innerHTML = `
          <div class="catalog-order-modal__overlay"></div>
          <div class="catalog-order-modal__content">
            <button class="catalog-order-modal__close" aria-label="Close">&times;</button>
            <h2 class="catalog-order-modal__title">Bestelgegevens</h2>
            <form class="catalog-order-form" id="catalogOrderForm">
              <div class="form-group">
                <label for="email">Email *</label>
                <input type="email" id="email" name="email" required>
              </div>
              
              <div class="form-group">
                <label for="naam">Naam *</label>
                <input type="text" id="naam" name="naam" required>
              </div>
              
              <div class="form-group">
                <label for="achternaam">Achternaam *</label>
                <input type="text" id="achternaam" name="achternaam" required>
              </div>
              
              <div class="form-group">
                <label for="adres">Adres *</label>
                <textarea id="adres" name="adres" rows="3" required></textarea>
              </div>
              
              <div class="form-group">
                <label for="telefoon">Telefoon/Gsm *</label>
                <input type="tel" id="telefoon" name="telefoon" required>
              </div>
              
              <div class="form-group">
                <label for="klantType">Klanttype *</label>
                <select id="klantType" name="klantType" required>
                  <option value="">Selecteer...</option>
                  <option value="Particulier">Particulier</option>
                  <option value="Zelfstandige">Zelfstandige</option>
                </select>
              </div>
              
              <div id="bedrijfsgegevens" class="bedrijfsgegevens-section" style="display: none;">
                <h3>Bedrijfsgegevens</h3>
                <div class="form-group">
                  <label>
                    <input type="checkbox" id="gebruikZelfdeGegevens">
                    Gebruik dezelfde gegevens als factuurgegevens
                  </label>
                </div>
                
                <div id="bedrijfsvelden">
                  <div class="form-group">
                    <label for="bedrijfsnaam">Bedrijfsnaam *</label>
                    <input type="text" id="bedrijfsnaam" name="bedrijfsnaam">
                  </div>
                  
                  <div class="form-group">
                    <label for="bedrijfsadres">Bedrijfsadres *</label>
                    <textarea id="bedrijfsadres" name="bedrijfsadres" rows="3"></textarea>
                  </div>
                  
                  <div class="form-group">
                    <label for="btwnummer">BTW-nummer *</label>
                    <input type="text" id="btwnummer" name="btwnummer">
                  </div>
                </div>
              </div>
              
              <div class="form-actions">
                <button type="button" class="button button--secondary" id="cancelOrder">Annuleren</button>
                <button type="submit" class="button button--primary">Bestelling plaatsen</button>
              </div>
            </form>
          </div>
        `;
        
        document.body.appendChild(modal);
        
        // Add styles
        if (!document.getElementById('catalog-order-modal-styles')) {
          const style = document.createElement('style');
          style.id = 'catalog-order-modal-styles';
          style.textContent = `
            .catalog-order-modal {
              position: fixed;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              z-index: 10000;
              display: flex;
              align-items: center;
              justify-content: center;
            }
            .catalog-order-modal__overlay {
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              background: rgba(0, 0, 0, 0.5);
            }
            .catalog-order-modal__content {
              position: relative;
              background: white;
              padding: 2rem;
              border-radius: 8px;
              max-width: 600px;
              width: 90%;
              max-height: 90vh;
              overflow-y: auto;
              z-index: 10001;
            }
            .catalog-order-modal__close {
              position: absolute;
              top: 1rem;
              right: 1rem;
              background: none;
              border: none;
              font-size: 2rem;
              cursor: pointer;
              line-height: 1;
            }
            .catalog-order-modal__title {
              margin-top: 0;
              margin-bottom: 1.5rem;
            }
            .catalog-order-form .form-group {
              margin-bottom: 1rem;
            }
            .catalog-order-form label {
              display: block;
              margin-bottom: 0.5rem;
              font-weight: 600;
            }
            .catalog-order-form input,
            .catalog-order-form textarea,
            .catalog-order-form select {
              width: 100%;
              padding: 0.75rem;
              border: 1px solid #ccc;
              border-radius: 4px;
              font-size: 1rem;
            }
            .bedrijfsgegevens-section {
              margin-top: 1.5rem;
              padding-top: 1.5rem;
              border-top: 1px solid #eee;
            }
            .form-actions {
              display: flex;
              gap: 1rem;
              margin-top: 2rem;
              justify-content: flex-end;
            }
          `;
          document.head.appendChild(style);
        }
        
        // Handle form submission
        const form = modal.querySelector('#catalogOrderForm');
        form.addEventListener('submit', (e) => {
          e.preventDefault();
          this.submitOrderWithCustomerData(form, modal);
        });
        
        // Handle cancel
        modal.querySelector('#cancelOrder').addEventListener('click', () => {
          document.body.removeChild(modal);
        });
        
        modal.querySelector('.catalog-order-modal__close').addEventListener('click', () => {
          document.body.removeChild(modal);
        });
        
        // Handle klantType change
        const klantTypeSelect = modal.querySelector('#klantType');
        const bedrijfsgegevensSection = modal.querySelector('#bedrijfsgegevens');
        const gebruikZelfdeCheckbox = modal.querySelector('#gebruikZelfdeGegevens');
        const bedrijfsvelden = modal.querySelector('#bedrijfsvelden');
        
        klantTypeSelect.addEventListener('change', (e) => {
          if (e.target.value === 'Zelfstandige') {
            bedrijfsgegevensSection.style.display = 'block';
          } else {
            bedrijfsgegevensSection.style.display = 'none';
          }
        });
        
        // Handle "gebruik zelfde gegevens" checkbox
        gebruikZelfdeCheckbox.addEventListener('change', (e) => {
          if (e.target.checked) {
            bedrijfsvelden.style.display = 'none';
            // Copy values
            document.getElementById('bedrijfsnaam').value = document.getElementById('naam').value + ' ' + document.getElementById('achternaam').value;
            document.getElementById('bedrijfsadres').value = document.getElementById('adres').value;
          } else {
            bedrijfsvelden.style.display = 'block';
          }
        });
      }

      submitOrderWithCustomerData(form, modal) {
        // Get product data
        const productId = this.dataset.productId;
        const variantId = this.getSelectedVariantId();
        const productLink = this.dataset.productUrl || window.location.pathname;
        const quantity = this.getQuantity();
        
        // Validate required data
        if (!productId) {
          this.handleErrorMessage('Product ID niet gevonden. Probeer de pagina te vernieuwen.');
          return;
        }
        if (!variantId) {
          this.handleErrorMessage('Product variant niet gevonden. Probeer de pagina te vernieuwen.');
          return;
        }
        
        // Format GIDs - ensure they're in the correct format
        // Product ID might be numeric or already in GID format
        let productGid = productId.toString();
        if (!productGid.startsWith('gid://shopify/Product/')) {
          // If it's just a number, format it as GID
          productGid = `gid://shopify/Product/${productGid}`;
        }
        
        // Variant ID might be numeric or already in GID format
        let variantGid = variantId.toString();
        if (!variantGid.startsWith('gid://shopify/ProductVariant/')) {
          // If it's just a number, format it as GID
          variantGid = `gid://shopify/ProductVariant/${variantGid}`;
        }
        
        // Get URL parameters
        const urlParams = new URLSearchParams(window.location.search);
        const companyGuid = urlParams.get('company_guid') || localStorage.getItem('company_guid');
        const urlGuid = urlParams.get('url_guid') || localStorage.getItem('url_guid');
        
        // Validate required parameters
        if (!companyGuid || !urlGuid) {
          alert('company_guid en url_guid zijn vereist. Controleer de URL parameters.');
          return;
        }
        
        // Get form data
        const formData = new FormData(form);
        const klantType = formData.get('klantType');
        const gebruikZelfdeGegevens = document.getElementById('gebruikZelfdeGegevens').checked;
        
        // Get or generate visitor ID
        let visitorId = localStorage.getItem('visitor_id');
        if (!visitorId) {
          visitorId = this.generateUUID();
          localStorage.setItem('visitor_id', visitorId);
        }
        
        // Prepare request data - using PascalCase to match C# model properties
        const requestData = {
          Id: this.generateUUID(),
          ShopifyProductGid: productGid,
          ShopifyVariantGid: variantGid,
          ProductLink: productLink.startsWith('http') ? productLink : `${window.location.origin}${productLink}`,
          Aantal: quantity,
          UserName: `${formData.get('naam')} ${formData.get('achternaam')}`,
          VisitorId: visitorId,
          UniqueUrlsId: urlGuid,
          Email: formData.get('email'),
          Naam: formData.get('naam'),
          Achternaam: formData.get('achternaam'),
          Adres: formData.get('adres'),
          Telefoon: formData.get('telefoon'),
          KlantType: klantType,
          GebruikZelfdeFactuurGegevens: klantType === 'Zelfstandige' ? gebruikZelfdeGegevens : false,
          Bedrijfsnaam: null,
          BedrijfsAdres: null,
          BTWNummer: null
        };
        
        // Add company details if Zelfstandige
        if (klantType === 'Zelfstandige') {
          if (gebruikZelfdeGegevens) {
            requestData.Bedrijfsnaam = `${formData.get('naam')} ${formData.get('achternaam')}`;
            requestData.BedrijfsAdres = formData.get('adres');
            requestData.BTWNummer = null; // Optional field
          } else {
            requestData.Bedrijfsnaam = formData.get('bedrijfsnaam') || null;
            requestData.BedrijfsAdres = formData.get('bedrijfsadres') || null;
            requestData.BTWNummer = formData.get('btwnummer') || null;
          }
        }
        
        // Show loading state
        const submitButton = form.querySelector('button[type="submit"]');
        submitButton.disabled = true;
        submitButton.textContent = 'Bezig met plaatsen...';
        
        // Make API call with company_guid and url_guid as query parameters
        const apiUrl = `${this.tileoServer}/Bestelling?company_guid=${encodeURIComponent(companyGuid)}&url_guid=${encodeURIComponent(urlGuid)}`;
        
        fetch(apiUrl, {
          method: 'POST',
          headers: {
            'accept': '*/*',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(requestData)
        })
          .then((response) => {
            if (!response.ok) {
              return response.json().then(err => Promise.reject(err));
            }
            return response.json();
          })
          .then((data) => {
            console.log('Order submitted successfully:', data);
            modal.querySelector('.catalog-order-modal__content').innerHTML = `
              <div style="text-align: center; padding: 2rem;">
                <h2>Bestelling geplaatst!</h2>
                <p>Bedankt voor uw bestelling. We hebben uw gegevens ontvangen.</p>
                <button class="button button--primary" onclick="location.reload()">Sluiten</button>
              </div>
            `;
          })
          .catch((error) => {
            console.error('Error submitting order:', error);
            alert('Er is een fout opgetreden bij het plaatsen van de bestelling: ' + (error.message || 'Onbekende fout'));
            submitButton.disabled = false;
            submitButton.textContent = 'Bestelling plaatsen';
          });
      }

      getSelectedVariantId() {
        // Try to get variant ID from the variant picker
        const variantInput = document.querySelector('[name="id"]');
        if (variantInput) {
          return variantInput.value;
        }
        
        // Fallback to data attribute
        return this.dataset.productGid || '';
      }

      getQuantity() {
        // Try to get quantity from quantity input
        const quantityInput = document.querySelector('.quantity__input');
        if (quantityInput && quantityInput.value) {
          return parseInt(quantityInput.value, 10) || 1;
        }
        
        // Fallback to 1 if not found
        return 1;
      }

      getUserName() {
        // Try to get user name from customer data
        if (window.Shopify && window.Shopify.customer) {
          return window.Shopify.customer.first_name + ' ' + window.Shopify.customer.last_name;
        }
        
        // Try to get from localStorage or other sources
        const storedUserName = localStorage.getItem('userName');
        if (storedUserName) {
          return storedUserName;
        }
        
        // Default fallback
        return 'string';
      }

      generateUUID() {
        // Simple UUID v4 generator
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
          const r = Math.random() * 16 | 0;
          const v = c === 'x' ? r : (r & 0x3 | 0x8);
          return v.toString(16);
        });
      }

      handleErrorMessage(errorMessage = false) {
        if (!this.errorMessageWrapper || !this.errorMessage) return;
        
        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
        
        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      showSuccessMessage() {
        // You can customize this to show a success notification
        // For example, using a toast notification or updating the button text
        if (this.submitButtonText) {
          const originalText = this.submitButtonText.textContent;
          this.submitButtonText.textContent = 'Bestelling geplaatst!';
          
          setTimeout(() => {
            this.submitButtonText.textContent = originalText;
          }, 3000);
        }
      }
    }
  );
}

